import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IProducts } from '../models/products.model';

export const pastProductsFromSomeoneElseFeatureKey = 'pastProductsFromSomeoneElse';

export interface PastProductsFromSomeoneElseState {
  loadPastProductsFromSomeoneElseResponse: IProducts[];
  loadPastProductsFromSomeoneElseFailure: Error | any;
}

export const initialState: PastProductsFromSomeoneElseState = {
  loadPastProductsFromSomeoneElseResponse: undefined,
  loadPastProductsFromSomeoneElseFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadPastProductsFromSomeoneElse, (state, action) => ({
    ...state
  })),
  on(actions.loadPastProductsFromSomeoneElseSuccess, (state, action) => ({
    ...state,
    loadPastProductsFromSomeoneElseResponse: action.response
  })),
  on(actions.loadPastProductsFromSomeoneElseFailure, (state, action) => ({
    ...state,
    loadPastProductsFromSomeoneElseFailure: action.error
  }))
);

export const getPastProductsFromSomeoneElseResponse = (state: PastProductsFromSomeoneElseState) =>
  state.loadPastProductsFromSomeoneElseResponse;
